// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sso-setup-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px 0;
}

.sso-provider-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  background: #f8fafc;
}

.provider-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.provider-header img {
  width: 24px;
  height: 24px;
}

.provider-header h3 {
  flex: 1 1;
  margin: 0;
  font-size: 16px;
  color: #0b3a42;
}

.provider-fields {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 36px;
}

.provider-fields input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
}

.setup-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #eaedeb;
    padding: 20px;
    font-family: 'Work Sans', sans-serif;
}

.setup-card {
    background: #fff;
    width: 100%;
    max-width: 480px;
    height: 90vh;
    max-height: 700px;
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0 15px 35px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.setup-header {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.setup-footer {
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 15px;
}

.setup-footer p {
    color: #999;
    font-size: 11px;
    margin: 0;
}

.setup-logo {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
}

.setup-header h1 {
    font-size: 24px;
    color: #2d3e50;
    margin: 0;
    font-weight: 700;
}

.setup-progress {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
}

.progress-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #e0e0e0;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    z-index: 2;
}

.progress-dot.active {
    background: #4c6371;
    color: white;
    box-shadow: 0 0 15px rgba(76, 99, 113, 0.3);
}

.progress-line {
    width: 25px;
    height: 2px;
    background: #e0e0e0;
    margin: 0 10px;
    max-width: 50px;
}

.setup-step h2 {
    color: #333;
    font-size: 20px;
    margin-bottom: 10px;
}

.setup-step {
    flex: 1 1;
    overflow-y: auto;
    padding-right: 10px;
    text-align: center;
}

/* Custom Scrollbar for the setup step */
.setup-step::-webkit-scrollbar {
    width: 6px;
}

.setup-step::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.setup-step::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
}

.setup-step::-webkit-scrollbar-thumb:hover {
    background: #999;
}

.welcome-illustration {
    margin-bottom: 15px;
}

.welcome-illustration img {
    width: 60px;
    height: 60px;
}

.feature-list {
    text-align: left;
    margin-bottom: 20px;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 8px;
}

.feature-icon {
    font-size: 20px;
}

.feature-text strong {
    display: block;
    font-size: 13px;
    color: #333;
}

.feature-text span {
    font-size: 11px;
    color: #777;
}

.setup-step p {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 20px;
}

.db-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 25px;
}

.db-option {
    display: flex;
    align-items: flex-start;
    padding: 15px;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: left;
}

.db-option:hover {
    border-color: #2a5298;
    background: rgba(42, 82, 152, 0.05);
}

.db-option.selected {
    border-color: #4c6371;
    background: rgba(76, 99, 113, 0.05);
}

.db-option input[type="radio"] {
    margin-top: 5px;
    margin-right: 15px;
}

.option-content strong {
    display: block;
    font-size: 16px;
    color: #333;
    margin-bottom: 4px;
}

.option-content span {
    font-size: 13px;
    color: #777;
    line-height: 1.4;
}

.status-indicator {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 25px;
}

.status-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    color: #555;
    font-size: 14px;
}

.status-item.success {
    color: #28a745;
    font-weight: 600;
}

.status-item.pending {
    color: #ffc107;
}

.form-group {
    text-align: left;
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #444;
    font-weight: 500;
    font-size: 14px;
}

.form-group input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.3s;
    box-sizing: border-box;
}

.form-group input:focus,
.setup-select:focus {
    outline: none;
    border-color: #4c6371;
    box-shadow: 0 0 0 3px rgba(76, 99, 113, 0.1);
}

.setup-select {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 15px;
    background-color: white;
    cursor: pointer;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 15px;
    transition: border-color 0.3s;
}

.setup-btn {
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.setup-btn.primary {
    background: #4c6371;
    color: white;
}

.setup-btn.primary:hover:not(:disabled) {
    background: #5a7585;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.setup-btn.tertiary {
    background: #f8f9fa;
    color: #4c6371;
    border: 1px solid #d0d7de;
    margin-bottom: 10px;
}

.setup-btn.tertiary:hover:not(:disabled) {
    background: #e1e7ef;
}

.setup-btn:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.setup-btn.back {
    background: transparent;
    color: #4c6371;
    border: 1.5px solid #c8d2da;
    font-size: 14px;
    padding: 12px 16px;
}

.setup-btn.back:hover:not(:disabled) {
    background: #f1f5f9;
    border-color: #4c6371;
    transform: translateY(-1px);
}

.button-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
}

.button-row {
    display: flex;
    gap: 10px;
}

.button-row .setup-btn {
    flex: 1 1;
}

.setup-error {
    background: #fff5f5;
    color: #c53030;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    border-left: 4px solid #c53030;
    text-align: left;
}

.setup-success {
    background: #f0fff4;
    color: #2f855a;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    border-left: 4px solid #2f855a;
    text-align: left;
}

.success-icon {
    font-size: 60px;
    color: #28a745;
    margin-bottom: 20px;
}

.setup-footer {
    margin-top: 30px;
    font-size: 12px;
    color: #999;
}

.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
    20%, 40%, 60%, 80% { transform: translateX(5px); }
}

@keyframes bounceIn {
    from, 20%, 40%, 60%, 80%, to { animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    0% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); }
    20% { transform: scale3d(1.1, 1.1, 1.1); }
    40% { transform: scale3d(0.9, 0.9, 0.9); }
    60% { opacity: 1; transform: scale3d(1.03, 1.03, 1.03); }
    80% { transform: scale3d(0.97, 0.97, 0.97); }
    to { opacity: 1; transform: scale3d(1, 1, 1); }
}

.fadeIn { animation-name: fadeIn; }
.shake { animation-name: shake; }
.bounceIn { animation-name: bounceIn; }

/* Detailed DB Config Styles */
.external-db-config {
    text-align: left;
}

.config-mode-toggle {
    display: flex;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.toggle-btn {
    flex: 1 1;
    padding: 8px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    color: #64748b;
    transition: all 0.2s ease;
}

.toggle-btn.active {
    background: white;
    color: #4c6371;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.form-row {
    display: flex;
    gap: 15px;
}

.form-row > .form-group {
    flex: 1 1;
}

.flex-2 { flex: 2 1 !important; }
.flex-1 { flex: 1 1 !important; }

.form-row-checkbox {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 5px;
    margin-bottom: 15px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
    cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.mssql-extras {
    padding: 15px;
    background: #f8fafc;
    border-radius: 8px;
    border-left: 3px solid #4c6371;
    margin-top: 10px;
    margin-bottom: 15px;
}

.driver-hint {
    display: block;
    margin-top: 10px;
    color: #64748b;
    font-style: italic;
}

.azure-firewall-hint {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #fffbeb;
    border: 1px solid #fcd34d;
    border-left: 4px solid #f59e0b;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 14px;
    text-align: left;
}

.azure-firewall-hint span {
    font-size: 18px;
    line-height: 1.4;
}

.azure-firewall-hint div {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.azure-firewall-hint strong {
    font-size: 12px;
    font-weight: 700;
    color: #92400e;
}

.azure-firewall-hint span:last-child,
.azure-firewall-hint div span {
    font-size: 11px;
    color: #78350f;
    line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Setup/SetupPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yDAA2R;IAC3R,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,WAAW,wBAAwB,EAAE;IACrC,0BAA0B,2BAA2B,EAAE;IACvD,qBAAqB,0BAA0B,EAAE;AACrD;;AAEA;IACI,+BAA+B,8DAA8D,EAAE;IAC/F,KAAK,UAAU,EAAE,iCAAiC,EAAE;IACpD,MAAM,iCAAiC,EAAE;IACzC,MAAM,iCAAiC,EAAE;IACzC,MAAM,UAAU,EAAE,oCAAoC,EAAE;IACxD,MAAM,oCAAoC,EAAE;IAC5C,KAAK,UAAU,EAAE,2BAA2B,EAAE;AAClD;;AAEA,UAAU,sBAAsB,EAAE;AAClC,SAAS,qBAAqB,EAAE;AAChC,YAAY,wBAAwB,EAAE;;AAEtC,8BAA8B;AAC9B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA,UAAU,oBAAkB,EAAE;AAC9B,UAAU,oBAAkB,EAAE;;AAE9B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".sso-setup-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 20px 0;\n}\n\n.sso-provider-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px;\n  background: #f8fafc;\n}\n\n.provider-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.provider-header img {\n  width: 24px;\n  height: 24px;\n}\n\n.provider-header h3 {\n  flex: 1;\n  margin: 0;\n  font-size: 16px;\n  color: #0b3a42;\n}\n\n.provider-fields {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-left: 36px;\n}\n\n.provider-fields input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.setup-container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #eaedeb;\n    padding: 20px;\n    font-family: 'Work Sans', sans-serif;\n}\n\n.setup-card {\n    background: #fff;\n    width: 100%;\n    max-width: 480px;\n    height: 90vh;\n    max-height: 700px;\n    padding: 30px;\n    border-radius: 20px;\n    box-shadow: 0 15px 35px rgba(0,0,0,0.2);\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n}\n\n.setup-header {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.setup-footer {\n    margin-top: 20px;\n    border-top: 1px solid #eee;\n    padding-top: 15px;\n}\n\n.setup-footer p {\n    color: #999;\n    font-size: 11px;\n    margin: 0;\n}\n\n.setup-logo {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 10px;\n}\n\n.setup-header h1 {\n    font-size: 24px;\n    color: #2d3e50;\n    margin: 0;\n    font-weight: 700;\n}\n\n.setup-progress {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 25px;\n}\n\n.progress-dot {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: #e0e0e0;\n    color: #333;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    z-index: 2;\n}\n\n.progress-dot.active {\n    background: #4c6371;\n    color: white;\n    box-shadow: 0 0 15px rgba(76, 99, 113, 0.3);\n}\n\n.progress-line {\n    width: 25px;\n    height: 2px;\n    background: #e0e0e0;\n    margin: 0 10px;\n    max-width: 50px;\n}\n\n.setup-step h2 {\n    color: #333;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.setup-step {\n    flex: 1;\n    overflow-y: auto;\n    padding-right: 10px;\n    text-align: center;\n}\n\n/* Custom Scrollbar for the setup step */\n.setup-step::-webkit-scrollbar {\n    width: 6px;\n}\n\n.setup-step::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n}\n\n.setup-step::-webkit-scrollbar-thumb {\n    background: #ccc;\n    border-radius: 10px;\n}\n\n.setup-step::-webkit-scrollbar-thumb:hover {\n    background: #999;\n}\n\n.welcome-illustration {\n    margin-bottom: 15px;\n}\n\n.welcome-illustration img {\n    width: 60px;\n    height: 60px;\n}\n\n.feature-list {\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.feature-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 10px;\n    padding: 10px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.feature-icon {\n    font-size: 20px;\n}\n\n.feature-text strong {\n    display: block;\n    font-size: 13px;\n    color: #333;\n}\n\n.feature-text span {\n    font-size: 11px;\n    color: #777;\n}\n\n.setup-step p {\n    color: #666;\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 20px;\n}\n\n.db-options {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 25px;\n}\n\n.db-option {\n    display: flex;\n    align-items: flex-start;\n    padding: 15px;\n    border: 2px solid #e0e0e0;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-align: left;\n}\n\n.db-option:hover {\n    border-color: #2a5298;\n    background: rgba(42, 82, 152, 0.05);\n}\n\n.db-option.selected {\n    border-color: #4c6371;\n    background: rgba(76, 99, 113, 0.05);\n}\n\n.db-option input[type=\"radio\"] {\n    margin-top: 5px;\n    margin-right: 15px;\n}\n\n.option-content strong {\n    display: block;\n    font-size: 16px;\n    color: #333;\n    margin-bottom: 4px;\n}\n\n.option-content span {\n    font-size: 13px;\n    color: #777;\n    line-height: 1.4;\n}\n\n.status-indicator {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 15px;\n    margin-bottom: 25px;\n}\n\n.status-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    color: #555;\n    font-size: 14px;\n}\n\n.status-item.success {\n    color: #28a745;\n    font-weight: 600;\n}\n\n.status-item.pending {\n    color: #ffc107;\n}\n\n.form-group {\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #444;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 12px 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 15px;\n    transition: border-color 0.3s;\n    box-sizing: border-box;\n}\n\n.form-group input:focus,\n.setup-select:focus {\n    outline: none;\n    border-color: #4c6371;\n    box-shadow: 0 0 0 3px rgba(76, 99, 113, 0.1);\n}\n\n.setup-select {\n    width: 100%;\n    padding: 12px 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 15px;\n    background-color: white;\n    cursor: pointer;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 15px center;\n    background-size: 15px;\n    transition: border-color 0.3s;\n}\n\n.setup-btn {\n    width: 100%;\n    padding: 14px;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.setup-btn.primary {\n    background: #4c6371;\n    color: white;\n}\n\n.setup-btn.primary:hover:not(:disabled) {\n    background: #5a7585;\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.setup-btn.tertiary {\n    background: #f8f9fa;\n    color: #4c6371;\n    border: 1px solid #d0d7de;\n    margin-bottom: 10px;\n}\n\n.setup-btn.tertiary:hover:not(:disabled) {\n    background: #e1e7ef;\n}\n\n.setup-btn:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n}\n\n.setup-btn.back {\n    background: transparent;\n    color: #4c6371;\n    border: 1.5px solid #c8d2da;\n    font-size: 14px;\n    padding: 12px 16px;\n}\n\n.setup-btn.back:hover:not(:disabled) {\n    background: #f1f5f9;\n    border-color: #4c6371;\n    transform: translateY(-1px);\n}\n\n.button-group {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.button-row {\n    display: flex;\n    gap: 10px;\n}\n\n.button-row .setup-btn {\n    flex: 1;\n}\n\n.setup-error {\n    background: #fff5f5;\n    color: #c53030;\n    padding: 12px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    border-left: 4px solid #c53030;\n    text-align: left;\n}\n\n.setup-success {\n    background: #f0fff4;\n    color: #2f855a;\n    padding: 12px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    border-left: 4px solid #2f855a;\n    text-align: left;\n}\n\n.success-icon {\n    font-size: 60px;\n    color: #28a745;\n    margin-bottom: 20px;\n}\n\n.setup-footer {\n    margin-top: 30px;\n    font-size: 12px;\n    color: #999;\n}\n\n.animated {\n    animation-duration: 0.5s;\n    animation-fill-mode: both;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes shake {\n    0%, 100% { transform: translateX(0); }\n    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\n    20%, 40%, 60%, 80% { transform: translateX(5px); }\n}\n\n@keyframes bounceIn {\n    from, 20%, 40%, 60%, 80%, to { animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n    0% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); }\n    20% { transform: scale3d(1.1, 1.1, 1.1); }\n    40% { transform: scale3d(0.9, 0.9, 0.9); }\n    60% { opacity: 1; transform: scale3d(1.03, 1.03, 1.03); }\n    80% { transform: scale3d(0.97, 0.97, 0.97); }\n    to { opacity: 1; transform: scale3d(1, 1, 1); }\n}\n\n.fadeIn { animation-name: fadeIn; }\n.shake { animation-name: shake; }\n.bounceIn { animation-name: bounceIn; }\n\n/* Detailed DB Config Styles */\n.external-db-config {\n    text-align: left;\n}\n\n.config-mode-toggle {\n    display: flex;\n    background: #f1f5f9;\n    padding: 4px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.toggle-btn {\n    flex: 1;\n    padding: 8px;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    background: transparent;\n    color: #64748b;\n    transition: all 0.2s ease;\n}\n\n.toggle-btn.active {\n    background: white;\n    color: #4c6371;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.form-row {\n    display: flex;\n    gap: 15px;\n}\n\n.form-row > .form-group {\n    flex: 1;\n}\n\n.flex-2 { flex: 2 !important; }\n.flex-1 { flex: 1 !important; }\n\n.form-row-checkbox {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #475569;\n    cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n}\n\n.mssql-extras {\n    padding: 15px;\n    background: #f8fafc;\n    border-radius: 8px;\n    border-left: 3px solid #4c6371;\n    margin-top: 10px;\n    margin-bottom: 15px;\n}\n\n.driver-hint {\n    display: block;\n    margin-top: 10px;\n    color: #64748b;\n    font-style: italic;\n}\n\n.azure-firewall-hint {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    background: #fffbeb;\n    border: 1px solid #fcd34d;\n    border-left: 4px solid #f59e0b;\n    border-radius: 8px;\n    padding: 10px 12px;\n    margin-bottom: 14px;\n    text-align: left;\n}\n\n.azure-firewall-hint span {\n    font-size: 18px;\n    line-height: 1.4;\n}\n\n.azure-firewall-hint div {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.azure-firewall-hint strong {\n    font-size: 12px;\n    font-weight: 700;\n    color: #92400e;\n}\n\n.azure-firewall-hint span:last-child,\n.azure-firewall-hint div span {\n    font-size: 11px;\n    color: #78350f;\n    line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
